

























































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PasswordInput from '@/modules/shared/components/shared/form/PasswordInput.vue'
import { StoreUserRequestModel } from '@/modules/user/models/user-request.model'
import AdminRoleSearch from '@/modules/role/components/admin/AdminRoleSearch.vue'
import { AdminStoreUserUseCase } from '@/modules/user/use-cases/admin/admin-store-user.use-case'

@Component({
  components: {
    AdminRoleSearch,
    PasswordInput,
    BaseInput,
    BaseButton
  }
})
export default class AdminCreateUserForm extends Vue {
  constructor(
    private readonly useCase: AdminStoreUserUseCase
  ) {
    super()
  }

  protected requestData: StoreUserRequestModel = {
    displayname: null,
    email: null,
    username: null,
    password: null,
    password_confirmation: null,
    phone: null,
    roles: []
  }

  protected setValue(key, value) {
    this.$set(this.requestData, key, value)
  }

  protected onSubmit() {
    this.useCase.execute(this.requestData)
      .onSuccess(() => {
        this.$emit('success')
      })
  }
}
